
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/snowflake-iceberg",
      function () {
        return require("private-next-pages/sources/snowflake-iceberg.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/snowflake-iceberg"])
      });
    }
  